import { render, staticRenderFns } from "./page-demo-csl.vue?vue&type=template&id=11f6d3be&scoped=true&"
import script from "./page-demo-csl.vue?vue&type=script&lang=js&"
export * from "./page-demo-csl.vue?vue&type=script&lang=js&"
import style0 from "./page-demo-csl.vue?vue&type=style&index=0&id=11f6d3be&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6d3be",
  null
  
)

export default component.exports